import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClientManagementService, Client } from '../../../services/client-management.service';
import { VmManagementService, VirtualMachine } from '../../../services/vm-management.service';
import { ProxmoxService } from '../../../services/proxmox.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  clients: Client[] = [];
  vms: VirtualMachine[] = [];
  clusterStatus: any = null;
  nodes: any[] = [];
  loading: boolean = false;
  error: string = '';
  successMessage: string = '';

  // Stats
  totalClients: number = 0;
  totalVMs: number = 0;
  runningVMs: number = 0;
  stoppedVMs: number = 0;

  constructor(
    private clientService: ClientManagementService,
    private vmService: VmManagementService,
    private proxmoxService: ProxmoxService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadDashboardData();
  }

  loadDashboardData(): void {
    this.loading = true;
    this.error = '';
    this.successMessage = '';

    // Load clients
    this.clientService.getClients().subscribe({
      next: (clients) => {
        this.clients = clients;
        this.totalClients = clients.length;
      },
      error: (error) => {
        console.error('Error loading clients:', error);
        this.error += 'Error loading clients. ';
      }
    });

    // Load VMs
    this.vmService.getVMs().subscribe({
      next: (vms) => {
        this.vms = vms;
        this.totalVMs = vms.length;
        this.runningVMs = vms.filter(vm => vm.status === 'running').length;
        this.stoppedVMs = vms.filter(vm => vm.status === 'stopped').length;
      },
      error: (error) => {
        console.error('Error loading VMs:', error);
        this.error += 'Error loading VMs. ';
      }
    });

    // Load Proxmox cluster data
    this.proxmoxService.getClusterStatus().subscribe({
      next: (response) => {
        this.clusterStatus = response.data || null;
      },
      error: (error) => {
        console.error('Error loading cluster status:', error);
        if (error.status !== 401) {
          this.error += 'Error loading cluster status. ';
        }
      }
    });

    this.proxmoxService.getNodes().subscribe({
      next: (response) => {
        this.nodes = response.data || [];
      },
      error: (error) => {
        console.error('Error loading nodes:', error);
        if (error.status !== 401) {
          this.error += 'Error loading nodes. ';
        }
      }
    });

    this.loading = false;
  }

  onViewClient(clientId: string): void {
    this.router.navigate(['/client-details', clientId]);
  }

  onViewVM(vmId: string): void {
    this.router.navigate(['/vm-details', vmId]);
  }

  onAddClient(): void {
    // Navigate to client registration page
    this.router.navigate(['/client-registration']);
  }

  onAddVM(): void {
    // Navigate to add VM page
    this.router.navigate(['/add-vm']);
  }

  refreshData(): void {
    this.loadDashboardData();
  }

  formatUptime(seconds: number): string {
    const days = Math.floor(seconds / (24 * 3600));
    seconds %= 24 * 3600;
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    seconds %= 60;

    let result = '';
    if (days > 0) result += days + 'd ';
    if (hours > 0) result += hours + 'h ';
    if (minutes > 0) result += minutes + 'm ';
    if (seconds > 0) result += seconds + 's';

    return result.trim();
  }

  getVMStatusClass(status: string): string {
    switch (status) {
      case 'running':
        return 'badge-success';
      case 'stopped':
        return 'badge-danger';
      case 'paused':
        return 'badge-warning';
      default:
        return 'badge-secondary';
    }
  }
}